<script lang="ts">
  import { onMount, getContext } from 'svelte';
  import { parse, parseISO, format, isValid } from 'date-fns';
  import { zonedTimeToUtc } from 'date-fns-tz';

  import { _ } from 'svelte-i18n';
  import { format_duration, format_duration_msf, parse_duration, validate_duration} from './time'
  import WorkoutPicker from './workouts/WorkoutPicker.svelte'
  import ParticipantList from './ParticipantList.svelte';
  import Select from 'svelte-select';
  import type { Writable } from 'svelte/store';
  import MyInput from './MyInput.svelte';
  import Fileuploader from './Bootstrap/Fileuploader.svelte';
  import YouTube from './YouTube.svelte';
  import WorkoutDetails from './workouts/WorkoutDetails.svelte';

  // Vars specific to instance scheduling, will be null for templates.
  export let session_id;
  export let start_date, repeat_type, sharing_type, allowed_users, members, is_group_session;
  export let invited_users, users_to_invite, users_to_schedule, community;
  export let is_zoom_media, zoom_autocreation, zoom_url;

  export let template_id;
  export let session_type; //session_type here refers to Personal/Community/Standard. maybe should rename officially to session_category
  export let owner_community;
  export let tags, venue, route_url, video_id, video_name, video_provider, video_offset, images;
  export let spotify_url;
  export let workout_id, workout_name, duration, name, description, xss, distance, elevation, focus, sfd, difficulty, rating;
  export let specificity, specRating, spr;
  export let owner;
  export let do_schedule_instance = false;
  export let is_owner: boolean;

  let video_channel;
  $: {
    if (video_channel == 'https://www.youtube.com/c/BiketheWorld')
      video_provider = 'bike_the_world';
    else
      video_provider = null;
  }

  let displayWorkouts: any;

  /**
   * Determines if the form will submit.
   * If it returns a false or falsy value, form will not submit.
   * Otherwise, if it returns true or truthy value, form should submit and session will be posted.
   */
  export function checkValidity() {
    console.log('checkValidity running...');
    console.log(session_form);
    console.log(template_selected_community_input);
    console.log(template_selected_community);
    console.log(instance_selected_community_input);
    console.log(instance_selected_community);

    setTimeout(()=> session_form.reportValidity(), 0);
    let fieldValidity = checkFieldValidity();
    let sharingValidity = checkSharingCommunityValidity();
    let ownerValidity = checkOwnerCommunityValidity();
    return fieldValidity && ownerValidity && sharingValidity
  }

  function checkFieldValidity() {
    let val = session_form.checkValidity();
    if (!val) {
      // Switch to Details tab to show invalid input messages..
      tab = 0;
    }
    return val;
  }

  // Community sessions must have an associated community input.
  function checkOwnerCommunityValidity() {
    // If we are scheduling an instance, or session type is not community, input is valid.
    if(do_schedule_instance || session_type !== 'Community') {
      return true;
    }
    if(template_selected_community_input) {
      if(template_selected_community == null) {
        tab = 0;
        template_selected_community_input.setCustomValidity($_('sessions.errors.required_input'));
        return false;
      } else {
        template_selected_community_input.setCustomValidity('');
        return true;
      }
    }
    return true;
  }

  // Group sessions must have a group to share with set.
  function checkSharingCommunityValidity() {
    // If we are creating/editing a template, or session is not a group session, input is valid.
    if(!do_schedule_instance || !is_group_session) {
      return true;
    }
    if(instance_selected_community_input) {
      if(instance_selected_community == null) {
        tab = 1;
        instance_selected_community_input.setCustomValidity($_('sessions.errors.required_input'));
        return false;
      } else {
        instance_selected_community_input.setCustomValidity('');
        return true;
      }
    }
    return true;
  }

  let session_form: HTMLFormElement;

  let image_form: HTMLFormElement;
  let images_to_delete = [];
  let image_request: RequestInit = getContext('fetch-request');
  delete image_request.headers['Content-Type'];
  export function uploadImages(session) {
    let image_id = session.template_id ?? template_id;
    let image_url = `${xert.Sessions.urls.createTemplate}/${image_id}/image`;
    let data = new FormData(image_form);
    images_to_delete.forEach(f => {
      data.append('delete[]', f);
    });
    return window.fetch(image_url, {
      ...image_request,
      method: 'POST',
      body: data,
    }).then(r=>r.json());
  }

  //let slider;

  let xert: any = getContext('xert');

  //let dateString = (date: Date) => date.toISOString().split('T')[0];
  let dateString = (date: Date) => isValid(date) ? format(date, 'yyyy-LL-dd') : '';
  let timeString = (date: Date) => format(date, 'HH:mm');
  function parseDateAndTime(date_string, time_string) {
    let dateAndTime = new Date('');
    let date = parseISO(date_string);
    if (!isValid(date)) return date;

    let timeFormats = [
      'HH', // 24 hour;
      'HH:mm',
      'hha',
      'hh:mma',
    ]
    time_string = time_string.replace(/\s/g, ''); // Remove whitespace with regex
    timeFormats.every(fmt=>{
        dateAndTime = parse(time_string, fmt, date);
        return !isValid(dateAndTime);
    });
    return dateAndTime;
  }

  // NOTE: datetime-local not yet implemented in some browsers,
  // https://html.spec.whatwg.org/multipage/input.html#local-date-and-time-state-(type=datetime-local)
  // https://caniuse.com/input-datetime
  // e.g. Firefox requires dom.forms.datetime.timepicker flag that isn't enabled by default.

  let start_date_obj: Date;
  let input_date: string;
  let input_time: string;
  if (do_schedule_instance) {
    start_date_obj = parseISO(start_date);
    input_date = dateString(start_date_obj);
    input_time = timeString(start_date_obj);
  }

  let clubs: Writable<[any]> = getContext('clubs');

  let club_items = [];
  $: club_items = ($clubs).map((c)=>{
    let type = $_('clubs.'+c.type);
    return {
      label: c.display_name,
      value: c.id,
      group: type,
    }
  });

  let club_users = [];
  let can_create_public = false;
  let instance_club_is_selected = false;
  function fetch_club_details(club_id) {
    // Reset all club related fields.
    console.log(`====> fetch_club_details: ${club_id}`);
    club_users = [];
    can_create_public = false;
    instance_club_is_selected = false;
    if (club_id == null) {
      sharing_type = null;
      return;
    }
    window.fetch(`${xert.Sessions.urls.clubs}/${club_id}`, {
      ...getContext('fetch-request')
    })
    .then(r=>r.json())
    .then(club_details=>{
      // Allow either owner, coach or squad member to make public sessions.
      can_create_public = club_details.is_owner || club_details.is_coach || club_details.is_squad_member;
      if (sharing_type == null || (sharing_type == 'public' && !can_create_public)) {
        sharing_type = 'community';
      }

      club_users = club_details?.users ?? [];
      instance_club_is_selected = true;
    });
  }

  const original_invited_users = allowed_users ?? [];
  users_to_invite = [...original_invited_users];
  const original_scheduled_users = (members ?? []).map(u=>u.id);
  users_to_schedule = [...original_scheduled_users];
  $: do_schedule_instance ? fetch_club_details(community) : fetch_club_details(owner_community);

  $: is_public = sharing_type == 'public';
  $: allow_edit_users = sharing_type == 'invite-only';

  function reset_invited_users(){
    users_to_schedule = [...original_scheduled_users]
    users_to_invite = [...original_invited_users];
  }

  // Clear community input if set to non-group-session.
  let template_selected_community = owner_community == null ? undefined : club_items.find(v=>v.value==owner_community);
  let template_selected_community_input;
  function initTemplateCommunity(_club_items) {
    let club_val = _club_items.find(v=>v.value==owner_community);
    if (club_val != null) {
      template_selected_community = club_val;
    }
  }
  $: if (owner_community != null) initTemplateCommunity(club_items);
  $: if (template_selected_community != null) owner_community = template_selected_community.value;

  let instance_selected_community = community == null ? undefined : club_items.find(v=>v.value==community);
  let instance_selected_community_input;
  function initInstanceCommunity(_club_items) {
    let club_val = _club_items.find(v=>v.value==community);
    if (club_val != null) {
      instance_selected_community = club_val;
    }
  }
  $: if (community != null) initInstanceCommunity(club_items);
  $: if (instance_selected_community != null) community = instance_selected_community.value;
  
  //let params = getContext('user_params');
  let user_params: Writable<any> = getContext('user_params');
  let template_type_items = [
    { label: 'Personal', value: 'Personal', },
    { label: 'Community', value: 'Community', },
    { label: 'Standard', value: 'Standard', },
  ];
  $: {
    template_type_items = ($user_params).allowed_session_types_to_create;
  }
  //console.log(($params).username);
  //console.log(($params).allowed_session_types_to_create);
  //$: is_admin = ($user_params).admin == true;
  $: trial = ($user_params).trial == true;

  let tags_items = [
    //"intense",
    //"uphill",
    //"todo"
  ].map(v=> { return {value:v, label:$_('sessions.tags.'+v, {default: v})} });
  //let selected_tags = tags == null ? undefined : tags_items.filter(v=>tags.includes(v.value));
  let selected_tags = tags == null ? undefined : tags.map(v=>{
    let tag = tags_items.find(t=>t.value==v);
    // TODO: escape() deprecated?
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/escape
    return tag ?? {value: v, label: encodeURIComponent(v)};
  })
  $: tags = selected_tags == null ? undefined : selected_tags.map((v)=>v.value);

  // TODO: Localize values
  let instance_type_items = [
    { label: 'Group', value: 'group', },
    { label: 'Solo', value: 'solo', },
  ];
  $: instance_type_items = $user_params.premium ? [
    { label: 'Group', value: 'group', },
    { label: 'Solo', value: 'solo', },
  ] : [ { label: 'Group', value: 'group' } ];
  let selected_instance_type = is_group_session ? instance_type_items[0] : instance_type_items[1];
  $: is_group_session = selected_instance_type.value == 'group';

  //let session_type_items = ($params).allowed_session_types_to_create;
  //let selected_session_type = session_type_items[0]; //Initialize. Later to selected tab? or allowed value.
  let selected_template_type = template_type_items[0];
  switch(session_type) {
    case 'Community': selected_template_type = template_type_items[1]; break;
    case 'Standard': selected_template_type = template_type_items[2]; break;
    default: selected_template_type = template_type_items[0]; break;
  }
  //session_type = selected_session_type.value;
  $: if (!do_schedule_instance) session_type = selected_template_type.value;

  let spotify_code = '';
  const generate_spotify_embed_code = (spotify_url?: string) => {
    if (!spotify_url) {
      return '';
    }
    let pattern = /open\.spotify\.com\/((?:artist)|(?:track)|(?:playlist)|(?:album))\/((?:[a-z]|[A-z]|[0-9])+)/;
    let matches = spotify_url.match(pattern);
    if (matches && matches.length === 3) {
      return (
        `<iframe width="100%" src="https://open.spotify.com/embed/${matches[1]}/${matches[2]}"` + 
        'frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>' 
      );
    }
    return '';
  }
  $: spotify_code = generate_spotify_embed_code(spotify_url);

  $: is_zoom_media = is_group_session && (zoom_autocreation || zoom_url);
  $: if (zoom_autocreation) {
    zoom_url = null;
  }
  let is_zoom_authorized;
  if (do_schedule_instance) onMount(async() => {
    // First time check
    window.fetch(`${xert.Sessions.urls.is_zoom_authorized}`, {
      method: 'get',
      credentials: 'same-origin',
    })
    .then(response => response.json())
    .then(data => {
      is_zoom_authorized = data.is_zoom_authorized;
      if (zoom_autocreation === null || zoom_autocreation === undefined) {
        zoom_autocreation = false; // zoom autocreation false by default
      }
    }).catch(error=>{
      console.log(error)
    });
  });
  else is_zoom_authorized = false;

  let venue_items = [
    { label: 'Indoor', value: 'indoor', },
    { label: 'Outdoor', value: 'outdoor', },
  ];
  let selected_venue = venue == null ? venue_items[0] : venue_items.find(v=>venue == v.value);
  $: venue = selected_venue == null ? undefined : selected_venue.value
  //$:is_outdoor = selected_venue != null && selected_venue.value == "outdoor";
  const is_outdoor = false;

  let route_embed = null;
  function parseRoute(url) {
    if (url == null){
      route_embed = null;
      route_embed = null;
      return;
    }
    let parts = url.split('/');
    if (url.includes('ridewithgps.com')) {
      let id = parts.find(v=>Number(v));
      if (id != null) {
        route_embed = `https://ridewithgps.com/embeds?type=route&id=${id}&sampleGraph=true`;
      } else {
        route_embed = null;
      }

    } else {
      route_embed = null;
    }

  }
  $: parseRoute(route_url);

  async function getWorkoutDetails(id) {
    console.log(`getWorkoutDetails called for ${id}`);
    if (id == null) return null;
    let w = displayWorkouts ? displayWorkouts.find(w=>w.path == id) : undefined;

    if (w) return w;
    else return await window.fetch(`/workouts/${id}`, {
      ...getContext('fetch-request'),
    })
    .then(r=>r.json())
  }

  // Don't select workout if outdoor session.
  let picked_workout_id = workout_id;
  let picked_workout;
  let can_override_session_description = description == null || description.length == 0;
  async function updatePickedWorkout(w_promise) {
    picked_workout = await w_promise;

    if (workout_id != null || picked_workout != null) {
      workout_name = picked_workout?.name;
      duration = picked_workout?.adu ?? 0;
      focus = picked_workout?.focus;
      sfd = picked_workout?.sfd;
      difficulty = picked_workout?.difficulty;
      specificity = picked_workout?.specificity;
      specRating = picked_workout?.specRating;
      xss = picked_workout?.xss;
      if (can_override_session_description) {
        description = picked_workout?.description;
      }
    }
  }
  $: updatePickedWorkout(getWorkoutDetails(workout_id))
  $: workout_id = is_outdoor ? undefined : picked_workout_id
  $: no_workout_selected = !(workout_id != null && workout_id.length > 0);

  // Combine separate date and time inputs into datetime string.
  // NOTE: This should be in the user's local timezone
  $: input_date_obj = parseDateAndTime(input_date, input_time);
  // Convert local timezone to UTC time for submission to the server.
  // $: if (isValid(input_date_obj)) start_date = zonedTimeToUtc(input_date_obj).toUTCString();
  $: if (isValid(input_date_obj)) start_date = input_date_obj.toUTCString();

  // Enter duration in minutes, but display in hh:mm:ss format.
  let duration_in_minutes = duration == null ? undefined : duration/60.0;
  $: duration = parse_duration(duration_in_minutes)*60;

  // Workouts
  let tab = 0;
  let video_url = video_id == null ? null : `https://www.youtube.com/watch?v=${video_id}`;

  $: if (!video_url) {
    video_id = null;
  }

  // Youtube
  let youtube;

  let details_size: ResizeObserverSize[] | null = null;
  let details_width: number | null = null;
  $: if (details_size && details_size[0]) details_width = details_size[0].inlineSize;
  function getReactiveGrid(w) {
    let n = w > 500 ? 4 : (w > 300 ? 2 : 1);
    let style = `grid-template-columns: repeat(${n}, minmax(0, 1fr));`;
    return style;
  }

  let media_size: ResizeObserverSize[] | null = null;
  let media_width: number | null = null;
  $: if (media_size && media_size[0]) media_width = media_size[0].inlineSize;
  const minimum_media_width = 500;
  function getMediaReactiveGrid(w) {
    let n = w > minimum_media_width ? 3 : 1;
    let style = `grid-template-columns: repeat(${n}, minmax(0, 1fr));`;
    return style;
  }

  let zoom_authorization_window;
  function openZoomAuthorizationWindow() {
    if (zoom_authorization_window && !zoom_authorization_window.closed) {
      zoom_authorization_window.focus();
    } else {
      zoom_authorization_window = window.open(
      '/authorize_zoom', 
      'Xert - Zoom Authorization',
      'width:30vh; height: 50vh'
      );
    }
    
    updateZoomAuthorization(zoom_authorization_window);
  }

  let zoom_deauthorization_window;

  function openZoomDeauthorizationWindow() {
    if (zoom_deauthorization_window && !zoom_deauthorization_window.closed) {
      zoom_deauthorization_window.focus();
    } else {
      zoom_deauthorization_window = window.open(
      '/deauthorize_zoom', 
      'Xert - Zoom Deauthorization',
      'width:30vh; height: 50vh'
      );
    }
    
    updateZoomAuthorization(zoom_deauthorization_window);    
  }

  function updateZoomAuthorization(_window) {
    let timer = setInterval(function() { 
      if(_window.document.getElementById('close-zoom-authorization-window')) {
          setTimeout(function () {
              _window.close();
          }, 3000);
      }
      
      if(_window.closed) {
          clearInterval(timer);
          
          // Update Data
          window.fetch(`${xert.Sessions.urls.is_zoom_authorized}`, {
            method: 'get',
            credentials: 'same-origin',
          })
          .then(response => response.json())
          .then(data => {
            is_zoom_authorized = data.is_zoom_authorized;
          }).catch(error=>{
            console.log(error)
          });
      }
    }, 1000);
  }

  let zoom_full_integration = getContext('zoom_full_integration');

  let repeat_items = [
    { label: $_('sessions.editor.labels.repeat-none'), value: 'none', },
    { label: $_('sessions.editor.labels.repeat-daily'), value: 'daily', },
    { label: $_('sessions.editor.labels.repeat-weekly'), value: 'weekly', },
    { label: $_('sessions.editor.labels.repeat-weekly-2'), value: 'weekly_2', },
    { label: $_('sessions.editor.labels.repeat-weekly-3'), value: 'weekly_3', },
    { label: $_('sessions.editor.labels.repeat-weekly-4'), value: 'weekly_4', },
  ];
  let selected_repeat = repeat_type == null ? repeat_items[0] : repeat_items.find(v=>repeat_type == v.value);
  $: repeat_type = selected_repeat == null ? undefined : selected_repeat.value

  function getReactiveColumn(w, column_start) {
    let style = `grid-column: ${w > 300 ? column_start+'/-1' : 'span 1'};`
    return style;
  }
</script>

<form bind:this={image_form} method="post" enctype="multipart/form-data" id="image_form"/>
<div class="flex-container"> <form bind:this={session_form} method="post" action="javascript:;">
  <ul class="nav nav-tabs-style override-tab-styles nav-tabs" style="flex-wrap: nowrap; flex-direction: row;">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <li class="tab-button" class:active={tab == 0} on:click={()=>tab = 0}>
      <a href="javascript:;"> {$_('sessions.editor.tabs.details')} </a>
    </li>
    {#if do_schedule_instance && is_group_session}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <li class="tab-button" class:active={tab == 1} on:click={()=>tab = 1}>
      <a href="javascript:;"> {$_('sessions.editor.tabs.sharing')} </a>
    </li>
    {/if}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <li class="tab-button" class:active={tab == 2} on:click={()=>tab = 2}>
      <a href="javascript:;"> {$_('sessions.editor.tabs.workout')} </a>
    </li>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <li class="tab-button" class:active={tab == 3} on:click={()=>tab = 3}>
      <a href="javascript:;"> {$_('sessions.editor.tabs.media')} </a>
    </li>
  </ul>
  <!--Slider bind:this={slider} bind:progress={slider_progress}-->
    <coarse-grid class:hidden={tab != 0}>
    <coarse-grid class="col-fill grid-outline">
    <grid-4 bind:borderBoxSize={details_size} style={getReactiveGrid(details_width)} class="col">

  <h4 class="bold col-fill">
    {$_('sessions.editor.details')}
  </h4>
  
  {#if !do_schedule_instance}
  <row-container> <span>{$_('sessions.editor.labels.session_category')}</span>
    <div class="my-input">
    <Select isClearable={false} bind:value={selected_template_type} items={template_type_items} />
    </div>
  </row-container>
  
  <row-container class:hidden={session_type != 'Community'}> <span>{$_('sessions.editor.labels.community')}</span>
    <div class="my-input" style="max-width: 300px;">
    <Select on:clear={()=>{
        owner_community = null;
      }} bind:value={template_selected_community} items={club_items} groupBy={(v)=>v.group} isMulti={false} bind:input={template_selected_community_input}/>
    </div>
  </row-container>
  {/if}

  <row-container class="col-fill"> <span>{$_('sessions.editor.labels.name')}</span>
    <input bind:value={name} required>
  </row-container>

  {#if do_schedule_instance}
  <row-container> <span>{$_('sessions.editor.labels.session_type')}</span>
    <div class="my-input">
    <Select isClearable={false} bind:value={selected_instance_type} items={instance_type_items} />
    </div>
  </row-container>

  <row-container>
    <span>{$_('sessions.editor.labels.repeat')}</span>
    <div class="my-input">
    <Select isClearable={false} bind:value={selected_repeat} items={repeat_items} />
    </div>
  </row-container>
  <row-container>
    <MyInput 
      label={$_('sessions.editor.labels.start_date')}
      type="date"
      required={true}
      min="{dateString(new Date())}"

      input={input_date}
      bind:output={input_date}
    />
  </row-container>
  <row-container>
    <MyInput 
      label={$_('sessions.editor.labels.start_time')}
      type="time"
      required={true}
      validate={(e)=>{
        let input = e.target;

        let date = parseDateAndTime(input_date, input.value);

        if (!isValid(date)) {
          input.setCustomValidity($_('sessions.errors.invalid_input'));
        } else {
          input.setCustomValidity('');
        }

        return input.value;
      }}

      input={input_time}
      bind:output={input_time}
    />
  </row-container>
  {/if}

  <row-container>
    {#if false}
     <span>{$_('sessions.editor.labels.venue')}</span>
    <div class="my-input">
    <Select isClearable={false} bind:value={selected_venue} items={venue_items} />
    </div>
    {:else}
    <MyInput 
      label={$_('sessions.editor.labels.venue')}
      type="text"

      input={selected_venue.label}
      enabled={false}
    />
    {/if}
  </row-container>

  <row-container style={getReactiveColumn(details_width, 2)}> <span>{$_('sessions.editor.labels.tags')}</span>
    <div class="my-input">
    <Select isCreatable={true} bind:value={selected_tags} items={tags_items} isMulti={true}/>
    </div>
  </row-container>

  <row-container>
    <MyInput 
      label={$_('sessions.editor.labels.duration')}
      enabled={no_workout_selected}
      units={$_('sessions.editor.labels.duration_minutes')}
      validate={validate_duration}

      input={format_duration(duration)}
      bind:output={duration_in_minutes}
    />
  </row-container>
  <row-container>
    <MyInput 
      label={$_('sessions.editor.labels.xss')}
      enabled={no_workout_selected}
      units={$_('sessions.editor.labels.xss_points')}

      input={Math.round(xss)}
      bind:output={xss}
    />
  </row-container>
  <row-container>
    <MyInput 
      label={$_('sessions.editor.labels.distance')}
      units={$_('sessions.editor.labels.km')}

      input={distance}
      bind:output={distance}
    />
  </row-container>
  <row-container>
    <MyInput 
      label={$_('sessions.editor.labels.elevation')}
      units={$_('sessions.editor.labels.meters')}

      input={elevation}
      bind:output={elevation}
    />
  </row-container>
  {#if !no_workout_selected}
  <row-container>
    <MyInput 
      label={$_('sessions.editor.labels.focus')}
      enabled={false}
      input={focus ? `${focus} - ${format_duration_msf(sfd)}` : ''}
    />
  </row-container>
  <row-container>
    <MyInput 
      label={$_('sessions.editor.labels.difficulty')}
      enabled={false}

      input={Math.round(difficulty)}
      bind:output={difficulty}
    />
  </row-container>
  <row-container>
    <MyInput 
      label={$_('sessions.editor.labels.specificity')}
      enabled={false}

      input={specRating ? `${Math.round(specificity*100)}% - ${specRating}` : ''}
      bind:output={spr}
    />
  </row-container>
  {/if}

    </grid-4>

    <grid-4 class="col">
      <row-container class="col-fill"> <span>{$_('sessions.editor.labels.description')}</span>
        <textarea maxlength="{4096}" class="my-input" on:input={(e)=>{
          if (e?.target?.value?.length > 0) {
            can_override_session_description = false;
          } else {
            can_override_session_description = true;
          }
        }} bind:value={description}/>
      </row-container>
    </grid-4>

    </coarse-grid>
    </coarse-grid>
    <coarse-grid class:hidden={tab != 2}>
    <coarse-grid class="col-fill">
    <div class="col flex-container grid-outline">

  <!-- CURENTLY UNUSED
    {#if is_outdoor}
      <row-container> <span>{$_("sessions.editor.labels.route")}</span>
        <input maxlength="{256}" bind:value={route_url}> </row-container>
          {#if route_embed}
            <iframe title="Route Map" src={route_embed} style="width: 1px; min-width: 100%; height: 700px; border: none;" scrolling="no"></iframe>
          {/if}
    {/if}
  -->

  <row-container style="flex-grow: 1;">
    <WorkoutPicker bind:displayWorkouts={displayWorkouts} bind:workout_id={picked_workout_id} {trial}/>
  </row-container>
      </div>
      {#if picked_workout}
        {#key picked_workout.path}
          <WorkoutDetails workout={picked_workout} showButtons={false}/>
        {/key}
      {/if}

    </coarse-grid>
    </coarse-grid>
    <coarse-grid class:hidden={tab != 3}>
      <coarse-grid class="col-fill grid-outline">
        <grid-4 bind:borderBoxSize={media_size} style={getMediaReactiveGrid(media_width)} class="col">
          <row-container class="col-fill"> 
            <h4 class="bold">
              {$_('sessions.editor.labels.youtube')}
            </h4>
          </row-container>
          <row-container class={ ((media_width > minimum_media_width) && video_url != null && video_url.length > 0) ? 'col-2-new': 'col-new' }>
            <span>{$_('sessions.editor.labels.video')}</span>
            <input maxlength="{256}" bind:value={video_url}> 
          </row-container>
          {#if video_url != null && video_url.length > 0}
          <input type="hidden" disabled bind:value={video_name}>
          <input type="hidden" disabled bind:value={video_provider}>
          <row-container> <span>{$_('sessions.editor.labels.video_offset')}</span>
            <input maxlength="{256}" type="number"  placeholder={$_('sessions.editor.labels.duration_seconds')} bind:value={video_offset}> </row-container>
          {/if}
        </grid-4>

        <!-- Right Box -->
        {#if video_url != null && video_url.length > 0}
        <YouTube bind:this={youtube} video_url={video_url} bind:video_id={video_id} bind:video_name={video_name} bind:video_channel={video_channel} start_seconds={video_offset}/>
        {/if}
      </coarse-grid>
      {#if do_schedule_instance}
      {#if is_group_session}
      <coarse-grid class="col-fill grid-outline">
        <grid-4 bind:borderBoxSize={media_size} style={getMediaReactiveGrid(media_width)} class="col">
          <row-container class="col-fill"> 
            <h4 class="bold">
              {$_('sessions.editor.labels.zoom')}
            </h4>
          </row-container>
          
            {#if zoom_full_integration}
              {#if is_zoom_authorized}
              <row-container>
                <br>
                <span class="content-center">
                  {$_('sessions.editor.labels.autocreate_zoom')}
                  <input style="margin-left:5px;" type="checkbox" bind:checked={zoom_autocreation}>
                </span>
              </row-container>
              <row-container>
                <br>
                <span class="content-center">
                  <button on:click={openZoomDeauthorizationWindow}>
                    <i class="fa fa-chain-broken" aria-hidden="true"/>
                    {$_('sessions.editor.labels.deauthorize_zoom')}
                  </button>
                </span>
              </row-container>
              {:else}
              <row-container class={ (media_width > minimum_media_width) ? 'col-2': '' }>
                <span class="content-center">
                  {$_('sessions.editor.labels.authorize_zoom')}
                  <i title={$_('sessions.editor.labels.why_authorize_zoom')} data-placement="right" class="fa-solid fa-question-circle"/>
                  :
                  <button style="background-color:Transparent; border:none; outline:none;" on:click={openZoomAuthorizationWindow}>
                    <img style="height:1em; margin:1em; min-height:18px; min-width:80px;" alt="Zoom Logo" src="/assets/images/ZoomLogo.png"> 
                  </button>
                </span>
              </row-container>
              {/if}
            {/if}
          {#if !zoom_autocreation}
          <row-container class="col-fill"> 
            <span>{$_('sessions.editor.labels.zoom_url')}</span>
            <input placeholder={$_('sessions.editor.labels.zoom_url_placeholder')} maxlength="{256}" bind:value={zoom_url}> 
            <br>
            <span class="subtext">{$_('sessions.editor.labels.zoom_url_recommendation_text')}</span>
            <ul>
              <li class="subtext">{$_('sessions.editor.labels.zoom_url_recommendation_1')}</li>
              <li class="subtext">{$_('sessions.editor.labels.zoom_url_recommendation_2')}</li>
            </ul>
            <span class="subtext">
              {$_('sessions.editor.labels.zoom_url_recommendation_more_info')}
              <a target="_session" href="https://support.zoom.us/hc/en-us/articles/202828525-Allow-participants-to-join-before-host">{$_('sessions.editor.labels.zoom_url_recommendation_more_info_title')}</a>
            </span>
          </row-container>
          {/if}
        </grid-4>

        <!-- Right Box -->
        {#if is_zoom_media}
          <img style="width:100%;" alt="Zoom Session Sample" src="/assets/images/ZoomSessionSample.png">
        {/if}
      </coarse-grid>
      {/if}
      {/if}

      <coarse-grid class="col-fill grid-outline">
        <grid-4 bind:borderBoxSize={media_size} style={getMediaReactiveGrid(media_width)} class="col">
          <row-container class="col-fill"> 
            <h4 class="bold">
              {$_('sessions.editor.labels.spotify')}
            </h4>
          </row-container>
          <row-container class="col-fill"> 
            <span>{$_('sessions.editor.labels.spotify_url')}</span>
            <input maxlength="{256}" bind:value={spotify_url}> 
          </row-container>
        </grid-4>

        {#if spotify_code}
          {@html spotify_code}
        {/if}
      </coarse-grid>

    <div class="col-fill flex-container grid-outline">
      <h4 class="bold">
        {$_('sessions.editor.upload')}
      </h4>
      <Fileuploader initial_files={images} bind:files_to_delete={images_to_delete} form_id="image_form"/>
    </div>


  </coarse-grid>
  {#if do_schedule_instance && is_group_session}
  <coarse-grid class:hidden={tab != 1}>
  <div class="col-fill grid-outline">
    <h4 class="bold text-center">
      {$_('sessions.editor.labels.community')}
    </h4>
    <row-container class="flex-row flex-centre"> <span class="margin-vcentre">{$_('sessions.editor.labels.community')}</span>
      <div class="my-input" style="margin: 10px; max-width: 300px;">
      <Select on:clear={()=>{
          console.log('community cleared ????');
          owner_community = null;
        }} bind:value={instance_selected_community} items={club_items} groupBy={(v)=>v.group} isMulti={false} bind:input={instance_selected_community_input}/>
      </div>
    </row-container>
    {#if instance_club_is_selected}
  <grid-3 class="grid-outline">
      <h4 class="bold">
        {#if allow_edit_users}
        {$_('sessions.editor.invite_members')}
        {:else}
        {$_('sessions.editor.group_members')} ({members?.length ?? 0})
        {/if}
      </h4>
      <radio-group class="flex-container flex-row flex-centre">
        {#if can_create_public}
          <input type="radio" id="public" name="invite" value="public" bind:group={sharing_type}>
          <label for="public">{$_('sessions.editor.labels.public')}</label> 
        {/if}
        <input type="radio" id="community" name="invite" value="community" bind:group={sharing_type}>
        <label for="community">{$_('sessions.editor.labels.invite-all')}</label> 
        <input type="radio" id="invite-only" name="invite" value="invite-only" bind:group={sharing_type}>
        <label for="invite-only">{$_('sessions.editor.labels.invite-only')}</label> 
      </radio-group>
  </grid-3>
  <div class="grid-outline">
    <ParticipantList {owner} {sharing_type} {allow_edit_users} {invited_users} {members} bind:users_to_invite={users_to_invite} {users_to_schedule} club_users={is_public ? [] : club_users} />
  </div>
  {/if}
  </div>
  </coarse-grid>
  {/if}
  <!--/Slider-->
</form></div>

<style lang="scss">
  // TODO: Figure out how to appy theme globally?
  @import './style/xert.scss';

  ::placeholder {
    opacity: 0.5;
  }

  .subtext {
    color: grey;
  }

  .content-center {
    position:relative; 
    left:50%; 
    transform:translate(-50%);
  }
  
  flex-container, .flex-container {
    display: flex;
    flex-direction: column;
    align-content: stretch;

    iframe {
      border: none;
    }
  }

  row-container, ul {
    //padding: 5px;
    display: flex;
    align-items: start;
    justify-content: flex-start;
    flex-wrap: wrap;
    flex-direction: column;

    &.flex-centre {
        justify-content: center;
    }

    > input, > .my-input {
      margin: 0;
      width: 100%;
    }
    textarea {
      flex-grow: 1;
      max-width: 100%;
      color: #4A4A4A;
      &:focus {
      }
    }



    .my-input {
      --height: 33.2px;
      --multiClearTop: 3px;
      --multiItemHeight: 22px;
      --clearSelectTop: 4px;
      --clearSelectBottom: 4px;
      --padding: 0.4em;
      --itemHoverBG: #4AA;
      --multiItemActiveBG: var(--color-xert-teal);
    }
}
grid-4 {
  > row-container {
      grid-column: span 1;
  }
}
  grid-3 {
    display: grid;
    grid-gap: 16px;
    > row-container {
      grid-column: span 1;
    }
    grid-template-columns: repeat(3, minmax(0, 1fr));
    @media(max-width: $media-size-lg) {
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }
  }
  .col {
    grid-column: span 1;
  }
  .col-fill {
    grid-column: 1 / -1;

  }
  
  .col-new {
    grid-column: 1;
  }
  .col-2 {
    grid-column: span 2;
  }
  .col-2-new {
    grid-column: 1 / span 2;
  }

  radio-group {
    grid-column: span 1;
    > input {
      margin: auto 0 auto 0;
    }
    > label {
      margin: auto 15px auto 5px;
    }

  }

  button.selecting_all {
    background-color: deepskyblue;
    color: white;
  }
  
</style>
